export const feature_groups = [
  { title: 'Features', group_key: 'features' },
  { title: 'Web EDITOR', group_key: 'web_editor' },
  { title: 'Shipping', group_key: 'shipping' },
  { title: 'Order Management', group_key: 'order_management' },
  { title: 'Revenue Models', group_key: 'revenue_models' },
  { title: 'Developers', group_key: 'developers' },
  { title: 'Communication', group_key: 'communication' },
  { title: 'Hosting & Security', group_key: 'hosting_security' },
  { title: 'Payment Methods', group_key: 'payment_methods' },
  { title: 'Support & Services', group_key: 'support' },
]

export const pricing_features = {
  visitors: {
    title: 'Visitors',
    group_name: 'Features',
    group_key: 'features',
    item_info: 'The number of users browsing your platform',
  },
  internal_users: {
    title: 'Internal Users',
    group_name: 'Features',
    group_key: 'features',
    item_info: 'The number of team/staff members using SuperAdmin/workspace',
  },
  external_users: {
    title: 'External Users',
    group_name: 'Features',
    group_key: 'features',
    item_info: 'Users signing up in your website & mobile app',
  },
  accounts: {
    title: 'Accounts',
    group_name: 'Features',
    group_key: 'features',
    item_info:
      'Also called as Seller, Multi Vendors, Campaign Creators, Merchants, Partners, Agency etc.',
  },
  listing: {
    title: 'Listing',
    group_name: 'Features',
    group_key: 'features',
    item_info: 'Also called as Products, Services, Campaigns, etc.',
  },
  stocks: {
    title: 'Stocks',
    group_name: 'Features',
    group_key: 'features',
    item_info: 'Stocks limits & Rules',
  },
  custom_fields: {
    title: 'Custom Fields/Attributes',
    group_name: 'Features',
    group_key: 'features',
    item_info: '9 types of custom fields for accounts, listings',
  },
  collection: {
    title: 'Collection',
    group_name: 'Features',
    group_key: 'features',
    item_info: 'Collection of listings & accounts',
  },
  geolocation: {
    title: 'Geolocation',
    group_name: 'Features',
    group_key: 'features',
    item_info:
      'Allow your users to add/browse accounts & listings with map browsing with distance filters',
  },
  social_engagements: {
    title: 'Social Engagements',
    group_name: 'Features',
    group_key: 'features',
    item_info: 'Follow, Like, Hashtags browsing',
  },
  quality_systems: {
    title: 'Quality Systems',
    group_name: 'Features',
    group_key: 'features',
    item_info: 'Approval, Ratings, Reviews, Report, Block, etc.',
  },
  bulk_operations: {
    title: 'Bulk Operations',
    group_name: 'Features',
    group_key: 'features',
    item_info: 'Import, Export',
  },
  schedules: {
    title: 'Schedules',
    group_name: 'Features',
    group_key: 'features',
    item_info: 'Allow people to book based on calendar',
  },
  simple_variant: {
    title: 'Simple Variant',
    group_name: 'Features',
    group_key: 'features',
    item_info: 'Allow your users to create variants under listing. Example: Color, size',
  },
  variant_matrix: {
    title: 'Variant Matrix(B2B)',
    group_name: 'Features',
    group_key: 'features',
    item_info:
      'Allow your users to choose a combination of variants under listing. Example: iPhone, 128GB, Color',
  },

  pricing_options: {
    title: 'Pricing Options',
    group_name: 'Features',
    group_key: 'features',
    item_info: 'Multiple Pricing under a single listing. Ex: Tickets',
  },

  multi_languages_multi_currencies: {
    title: 'Multi Languages & Multi Currencies',
    group_name: 'Features',
    group_key: 'features',
    item_info: 'Features on SuperAdmin',
  },
  search_engine_indexing: {
    title: 'Search Engine Indexing (SEO)',
    group_name: 'Features',
    group_key: 'features',
    item_info: 'Indexing, Custom scripting across platforms',
  },
 
  social_login: {
    title: 'Social Login',
    group_name: 'Features',
    group_key: 'features',
    item_info: 'Giving your users a Login via Google, Facebook/Meta',
  },
  single_signon: {
    title: 'Single Sign On',
    group_name: 'Features',
    group_key: 'features',
    item_info: 'Give your platform access to access via Single Sign On. Useful for Enterprises and Existing websites',
  },


  
  storage_limit: {
    title: 'Storage Limit',
    group_key: 'hosting_security',
    item_info: 'All time total file size of images, videos, etc.',
  },
  layers_advanced_cms: {
    title: 'Layers - Advanced CMS',
    group_key: 'web_editor',
    item_info: 'Blogs, Pages, Dynamic Builder Pages, Custom Types',
  },
  website_templates: {
    title: 'Website Templates',

    group_key: 'web_editor',
    item_info: 'Hosted on Tradly',
  },
  page_history: {
    title: 'Page Version History - Days',
    group_name: 'Web EDITOR',
    group_key: 'web_editor',
    item_info: 'History of the edits available to revert back',
  },
  integrations: {
    title: 'Web Integrations',
    group_name: 'Web EDITOR',
    group_key: 'web_editor',
    item_info: '3rd Party Integrations you can add to your website without code.',
  },
  basic_rules: {
    title: 'Basic Rules',
    group_name: 'Web EDITOR',
    group_key: 'web_editor',
    item_info:
      'Visibility Rules on block level for logged in, logout. Currently available on few blocks.',
  },
  css_level_edit: {
    title: 'CSS Level Edit',
    group_name: 'Web EDITOR',
    group_key: 'web_editor',
    item_info: 'Spacing, Size, Position, Background, etc.',
  },
  advanced: {
    title: 'Advanced Workflow',
    group_name: 'Web EDITOR',
    group_key: 'web_editor',
    item_info: 'Mobile Separate CSS, Draft/Live Mode, Copy/Paste Style',
  },

  custom_code_injection: {
    title: 'Custom Code Injection',
    group_name: 'Web EDITOR',
    group_key: 'web_editor',
    item_info: 'Add custom code',
  },

  advanced_rules: {
    title: 'Advanced Rules',
    group_name: 'Web EDITOR',
    group_key: 'web_editor',
    item_info:
      'Visibility Rules for paid subscribed member (applicable to subscription business model)',
  },
  shipping_logics: {
    title: 'Shipping Logics',
    group_name: 'Shipping',
    group_key: 'shipping',
    item_info: 'Fee calculation, Insert Tracking Number, Coming Soon (Country & Pincode level fee)',
  },
  custom_logics: {
    title: 'Custom Logics',
    group_name: 'Shipping',
    group_key: 'shipping',
    item_info:
      'Add or remove delivery, Pickup & Storage Hub (Warehouse, Pickup points), Find Store',
  },
  fulfillment_by_platform: {
    title: 'Fulfillment by Platform',
    group_name: 'Shipping',
    group_key: 'shipping',
    item_info: 'Platform able to manage shipping of their sellers.',
  },
  cart_based_ordering: {
    title: 'Cart based Ordering',
    group_name: 'Order Management',
    group_key: 'order_management',
    item_info: 'For e-commerce product shopping',
  },
  direct_booking_order: {
    title: 'Direct Booking/order',
    group_name: 'Order Management',
    group_key: 'order_management',
    item_info: 'For Event Booking, SaaS Appstore, etc',
  },

  order_status_workflow: {
    title: 'Order status workflow',
    group_name: 'Order Management',
    group_key: 'order_management',
  },
  order_status_flow_persistent_messages: {
    title: 'Order Status flow persistent messages',
    group_name: 'Order Management',
    group_key: 'order_management',
  },
  transaction_split: {
    title: 'Transaction Split',
    group_name: 'Order Management',
    group_key: 'order_management',
    item_info: 'Platform Commission, Shipping, Payout, PG Fee',
  },
  other_order_logics: {
    title: 'Other Order Logics',
    group_name: 'Order Management',
    group_key: 'order_management',
    item_info: 'Min quantity rule, min and max amount per order, saved address',
  },
  negotiation_offer_price: {
    title: 'Negotiation / Offer price',
    group_name: 'Order Management',
    group_key: 'order_management',
    item_info: 'Plus Expiry time for negotiated price',
  },

  special_fees: {
    title: 'Special Fees (Price Markup)',
    group_name: 'Revenue Models',
    group_key: 'revenue_models',
  },
  commission_deduction: {
    title: 'Commission deduction',
    group_name: 'Revenue Models',
    group_key: 'revenue_models',
  },
  gated_subscription_on_platform: {
    title: 'Gated Subscription on Platform(*1)',
    group_name: 'Revenue Models',
    group_key: 'revenue_models',
  },
  subscription_on_listing: {
    title: 'Subscription on Listing (*1)',
    group_name: 'Revenue Models',
    group_key: 'revenue_models',
  },
  api_reference_sdk_support: {
    title: 'API Reference & SDK Support',
    group_name: 'Developers',
    group_key: 'developers',
    item_info: 'REST API, JS SDK',
  },
  api_rate_limit: {
    title: 'API Rate Limit',
    group_name: 'Developers',
    group_key: 'developers',
    item_info: 'Number of request per minute',
  },
  open_source_apps_support: {
    title: 'Open Source Apps Support',
    group_name: 'Developers',
    group_key: 'developers',
    item_info: 'CRA, NextJS, React Native, Flutter',
  },
  webhooks: {
    title: 'Webhooks',
    group_name: 'Developers',
    group_key: 'developers',
    item_info: 'Ready Trigger events to 3rd party tools like Zapier, Make.',
  },
  headless_api_access: {
    title: 'Headless API access',
    group_name: 'Developers',
    group_key: 'developers',
    item_info: 'Partner developers has separate access',
  },

  email_from_address: {
    title: 'Email "From Address"',
    group_name: 'Communication',
    group_key: 'communication',
    item_info: 'System emails (OTP emails, order emails, etc)',
  },
  customize_email_templates: {
    title: 'Customize Email Templates',
    group_name: 'Communication',
    group_key: 'communication',
    item_info: 'System emails (Welcome, OTP emails, order emails, etc)',
  },
  in_app_chat: {
    title: 'In-App Chat',
    group_name: 'Communication',
    group_key: 'communication',
    item_info: 'Between your users in mobile app',
  },
  web_app_deployment: {
    title: 'Web App Hosting',
    group_name: 'Hosting & Security',
    group_key: 'hosting_security',
    item_info: 'Hosting the web apps under Tradly Hosting',
  },
  ssl: {
    title: 'SSL',
    group_name: 'Hosting & Security',
    group_key: 'hosting_security',
    item_info: 'SSL Cert',
  },

  sites: {
    title: 'Number of Sites under workspace',
    group_name: 'Hosting & Security',
    group_key: 'hosting_security',
    item_info: 'Number of sites under single project/tenant',
  },
  custom_domain: {
    title: 'Custom Domain',
    group_name: 'Hosting & Security',
    group_key: 'hosting_security',
    item_info: 'Web App',
  },
  rbac: {
    title: 'RBAC',
    group_name: 'Hosting & Security',
    group_key: 'hosting_security',
    item_info: 'Roll based access control across every features',
  },
  managed_support: {
    title: 'Managed Support (Android, iOS)',
    group_name: 'Hosting & Security',
    group_key: 'hosting_security',
    item_info: 'If you have purchased mobile app code',
  },
  stripe: {
    title: 'Stripe',
    group_name: 'Payment Methods',
    group_key: 'payment_methods',
    item_info: '50+ Countries, Payemnnts, Connect for marketplace (Standard & Express)',
  },

  paydunya: {
    title: 'PayDunya (*3)',
    group_name: 'Payment Methods',
    group_key: 'payment_methods',
    item_info: 'Senegal, Ivory Coast and the Republic of Benin',
  },
  pawapay: {
    title: 'Pawapay(19)',
    group_name: 'Payment Methods',
    group_key: 'payment_methods',
    item_info: 'Africa',
  },
  others: {
    title: 'Others',
    group_name: 'Payment Methods',
    group_key: 'payment_methods',
    item_info: 'Razorpay(IN), Billpay(MY), OnlinePaymentPlatform(EU)',
  },
  cash_based: {
    title: 'Cash Based',
    group_name: 'Payment Methods',
    group_key: 'payment_methods',
    item_info: 'Cash on delivery/pickup, etc',
  },
  payu: {
    title: 'PayU (*3)',
    group_name: 'Payment Methods',
    group_key: 'payment_methods',
    item_info: 'Colombia, Argentina, Brazil, Mexico, Chile, Peru and Panama',
  },
  mangopay: {
    title: 'MangoPay',
    group_name: 'Payment Methods',
    group_key: 'payment_methods',
    item_info: '31 European Economic Area (EEA) + UK',
  },
  myfatoorah: {
    title: 'Myfatoorah',
    group_name: 'Payment Methods',
    group_key: 'payment_methods',
    item_info: 'KW, SA, BH, UAE, QA, EG, Oman, JO',
  },

  additional_payments: {
    title: 'Additional Payments',
    group_name: 'Payment Methods',
    group_key: 'payment_methods',
    item_info: 'With implementation charges - on-demand implementation',
  },
  self_help: {
    title: 'Video Tutorials & Self Help',
    group_name: 'Support',
    group_key: 'support',
    item_info: 'Documentation access. Video tutorials in different channels',
  },
  
  community_forum: {
    title: 'Community Forum',
    group_name: 'Support',
    group_key: 'support',
    item_info: 'Discussing with community and helping each other',
  },

  support_desk: {
    title: 'Support Portal',
    group_name: 'Support',
    group_key: 'support',
    item_info: 'Submit tickets via Support Portal with Standard SLA',
  },
  live_chat: {
    title: 'Live Chat',
    group_name: 'Support',
    group_key: 'support',
    item_info: 'Live Chat with Standard SLA',
  },
  sales_call: {
    title: 'Sales & Consulting - Google Meet Call',
    group_name: 'Support',
    group_key: 'support',
    item_info: 'Scheduled Google Meet call to understand custom development needs',
  },
  
  custom_development_services: {
    title: 'Custom Development Services',
    group_name: 'Support',
    group_key: 'support',
    item_info: 'Additional custom integration of 3rd Party Services',
  },
  account_manager: {
    title: 'Customer Success Manager',
    group_name: 'Support',
    group_key: 'support',
    item_info: 'Single point of contact for all your communication',
  },
  priority_desk: {
    title: 'Priority Case Management',
    group_name: 'Support',
    group_key: 'support',
    item_info: 'Faster priority support for your team on critical things',
  },
  
  

}
